import { useMemo } from 'react';

import { pipe } from 'fp-ts/lib/function';
import setSeconds from 'date-fns/fp/setSeconds';
import setMilliseconds from 'date-fns/fp/setMilliseconds';
import startOfDay from 'date-fns/startOfDay';

export const useNow = () => {
  return useMemo(() => pipe(new Date(), setSeconds(0), setMilliseconds(0)), []);
};

export const useToday = () => {
  return startOfDay(useNow());
};
